import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {ExtraInfoLayout, RolePageHeroFigure} from "@repo/auth-shared";
import {mediaQueries} from "@repo/shared-styles";

import PageRoot from "#app-shell-package/page-root.tsx";
import SmartRedirect from "#shared/app-shell/smart-redirect.tsx";

import {RolePicker} from "./role-picker.tsx";
import useBypassRolePicker from "./use-bypass-role-picker.tsx";

/**
 * Page for choosing a primary role (Learner, Teacher, or Parent) during sign
 * up.
 */
const ChooseRolePage = () => {
    const learnerNextUrl = "/signup/learner/birthday";
    const teacherNextUrl = "/signup/teacher";
    const parentNextUrl = "/signup/parent";

    const bypassResult = useBypassRolePicker();
    if (bypassResult.status === "success" && bypassResult.role) {
        if (bypassResult.role === "learner") {
            return <SmartRedirect to={learnerNextUrl} />;
        }
        if (bypassResult.role === "teacher") {
            return <SmartRedirect to={teacherNextUrl} />;
        }
        if (bypassResult.role === "parent") {
            return <SmartRedirect to={parentNextUrl} />;
        }
    }

    return (
        <PageRoot settings={{footer: false}}>
            <View style={styles.page}>
                <ExtraInfoLayout
                    leftComponent={<RolePageHeroFigure />}
                    rightComponent={
                        <RolePicker
                            title={t`Sign up for Khan Academy!`}
                            infoText={<InfoText />}
                            learnerNextUrl={learnerNextUrl}
                            teacherNextUrl={teacherNextUrl}
                            parentNextUrl={parentNextUrl}
                        />
                    }
                    columnTemplate="60% 40%"
                />
            </View>
        </PageRoot>
    );
};

export const InfoText = () => (
    <Trans>
        Are you a district admin? Learn more of our offerings on{" "}
        <Link href="https://districts.khanacademy.org">our district page</Link>.
    </Trans>
);

const styles = StyleSheet.create({
    page: {
        alignItems: "center",
        [mediaQueries.lgOrLarger]: {
            padding: `${spacing.xxxLarge_64}px 0`,
        },
    },
});

export default ChooseRolePage;
